import { IPipefyOption } from "components/Select/interface";
import { ICustomer } from "./Customer";
import { IUser } from "./User";
import { IOrders } from "./Order";

export interface ITicketsData {
  data: Array<ITickets>;
}
export interface IRequestProtocol {
  data: {
    data?: Array<ITicketsData>;
    maxPageSize?: number;
    pageSize?: number;
    total?: number;
    totalPages?: number;
  };
}

export enum TicketCategoryTypeNumber {
  "ATENDIMENTO",
  "DEVOLUÇÃO",
  "FATURAMENTO",
  "FINANCEIRO",
  "RASTREAMENTO DE PEDIDO",
  "LOGÍSTICA",
  "COMERCIAL",
  "RECLAMAÇÃO TÉCNICA",
  "SOLICITAÇÃO DE INFORMAÇÃO/SERVIÇO"
}

export enum ITicketAttendanceType {
  SELF_SERVICE = "Auto atendimento",
  SERVED_BY_ATTENDENT = "Atendido por Atendente",
}

export enum ILegalPersonType {
  JURIDICAL_PERSON = 1,
  NATURAL_PERSON = 2,
  MANUAL_CUSTOMER_CONSUMER = 3,
  DIRECT_CUSTOMER = 1,
  FINAL_CONSUMER = 2
}

export enum EnumCategories {
  ATENDIMENTO = "0",
  DEVOLUCAO = "1",
  FATURAMENTO = "2",
  FINANCEIRO = "3",
  RASTREAMENTO_DE_PEDIDO = "4",
  LOGISTICA = "5",
  COMERCIAL = "6",
  RECLAMACAO_TECNICA = "7",
  SOLICITACAO_DE_INFORMACAO_SERVICO = "8",
  OCORRENCIA_TRANSPORTADORA = "11"
}

export enum EnumReason {
  INSTRUCAO_DE_USO = "35",
  CARTA_DE_TROCA = "47",
  ENVIO_DE_CTE = "55",
  ENVIO_XML_DE_CTE = "56",
  FALTA_DE_VOLUME = "61"
}

export enum ITicketStatusType {
  QUEUED = 0,
  IN_ATTENDANCE = 1,
  DONE = 2
}

export enum IReturnType {
  ON_DELIVERY = "No Ato da Entrega",
  AFTER_DELIVERY = "Após a Entrega"
}

export enum EnumReturnTypeValueProps {
  ON_DELIVERY = "ON_DELIVERY",
  AFTER_DELIVERY = "AFTER_DELIVERY"
}

export interface ITickets {
  id?: string;
  protocolNumber: string;
  legalPerson: keyof typeof ILegalPersonType;
  userTypeProtocol: keyof typeof ILegalPersonType;
  customerId: string;
  customerName: null;
  communicationChannel: string;
  protocolCategory: string;
  ticketReason: string;
  statusType: keyof typeof ITicketStatusType;
  protocolClassification: string;
  contactName: string;
  contactMailAddress: string;
  contactPhoneNumber: string;
  orderIdentifier: string;
  product: Array<any>;
  order: IOrders;
  description: string;
  tags: Array<string>;
  linkTicketIdentifier: string;
  readyForResolution: string;
  createdDate: string;
  updatedDate: string;
  userWhoCreatedId: null;
  userWhoUpdatedId: null;
  attendenceType: ITicketAttendanceType;
  company?: ICustomer;
  brands: string;
  responsibleGroup?: string;
  userWhoCreated?: IUser;
  productRI?: string;
  isAbleToEdit: boolean;
  occurrenceDate: string,
  businessPosition: string,
  balanceRemaining: true,
  occurrenceType: string,
  occurrenceTypeDescription: string,
  sampleType: string,
  availableSampleCollection: false,
  ticketCategoryView: IPipefyOption,
  ticketReasonView: IPipefyOption,
  ticketClassificationView: IPipefyOption;
  cnpj?: string;
  reclamationPrice?: number;
  requesterDescription?: string;
  solutionType?: string;
  isAbleToResendDevolutionApprovalMail: boolean;
  isAbleToReviewOrderLostProcess: boolean;
  isAbleAdverseEventsProcess: boolean;
}

export interface IRequestFilter {
  protocolNumber?: number | string;
  startPeriod?: string;
  lastPeriod?: string;
  keyword?: string;
  bus?: Array<string>;
  categories?: Array<any>;
  reasons?: Array<any>;
  responsibleGroups?: Array<string>;
  subsidiaryIds?: Array<string>;
  phaseStatus?: Array<string>;
  brands?: Array<string>;
  statusType?: Array<number>;
  currentPage?: number;
  pageSize?: number;
  sortBy?: string;
  sortDirection?: string;
  customerIds?: string | null;
  protocolOrigin?: string;
}

export interface ScheduleTicketProps {
  schedulingDate: string;
  description: string;
}

export const categoriesToDisplayInConsumerManualProtocols = [
  'ATENDIMENTO',
  'LOGÍSTICA',
  'RASTREAMENTO DE PEDIDO',
  'FINANCEIRO',
  'RECLAMAÇÃO TÉCNICA',
  'DEVOLUÇÃO'
];

export const reasonsToHideProtocolsConsumerManual = [
  'CARTA DE CORREÇÃO',
  'ATUALIZAÇÃO DE DOCUMENTOS',
  'DOCUMENTOS LEGAIS',
  'DOCUMENTOS REGULATÓRIOS',
  'EXTRAÇÃO DE FOLLOW-UP NÃO ENTREGA',
  'EXTRAÇÃO DE FOLLOW-UP ENTREGA',
  'EXTRAÇÃO DE VENDAS TRIANGULARES',
  'EXTRAÇÃO DE PEDIDOS'
];

export enum TicketTabsEnum {
  PROTOCOLO_ABERTO = "protocolo_aberto",
  PROTOCOLO_FECHADO = "protocolo_fechado",
}

export enum ManualSubsidiariesEnum {
  FLEXICOTTON_FW_DAVISO = 9999,
  PFS = 9998,
  NEVE = 9997
}

export enum EnumNameProtocolStatus {
  AVALIACAO_COMERCIAL = 'avaliação comercial',
  AVALIACAO_LOGISTICA = 'avaliação torre de controle'
}

export enum EnumProfileType {
  INTERNAL_COMMERCIAL = 'INTERNAL_COMMERCIAL',
  DEVOLUTION_SEGREGATED_MANAGEMENT = 'DEVOLUTION_SEGREGATED_MANAGEMENT'
}